module.exports = __webpack_public_path__ + "static/media/pause.8e7166d4.svg";